<div class="cppSulfurZinc">
  <div class="row">
    <div class="col-8">
      <h3 class="">Sulfur & Zinc Sulfate Pricing</h3>
    </div>
    <div class="col-4 text-right m-auto padding-r0">
      <span class="manage-subs">
        <i class="fa fa-envelope" aria-hidden="true"></i>
        <a href="Javascript:void(0);" (click)="redirectToSubscription()">Manage Subscriptions</a>
      </span>
      <span class="manage-subs">
        <img src="../assets/icon/svg/manage-reports.svg" (click)="selectFilter()" />
        <a href="Javascript:void(0);" (click)="selectFilter()">MANAGE REPORTS</a>
      </span>
    </div>
  </div>

  <div class="nplPage priceListPageClass-wrapper" style="width: 100%; margin:0;">
    <div class="priceLists margin-0">
      <div class="topSection">
        <div class="alignTopSec">
          <div class="form-sec">
            <div class="col-sm-12 col-md-12 col-lg-12 smallPadRgt0 padding-l0">
              <div class="row search-box-outer ">
                <div class="col-3 padding-r30">
                  <div class="category-dropdown material-select">
                    <ng-select [items]="productTypeData" [clearSearchOnAdd]="true"
                               [closeOnSelect]="false" labelForId="productType" [multiple]="true" placeholder="Select Product Type"
                               [(ngModel)]="searchproductType" (change)="filterRecords()" [searchFn]="ddlOptionsSearchProductType"
                               [selectableGroupAsModel]="false" groupBy="selectedAllGroupProductType" [selectableGroup]="true" bindValue="productType"
                               [keyDownFn]="handleKeyevent"
                               clearAllText="Clear" [bindLabel]="'text'">
                      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index}}" type="checkbox"
                                 [ngModel]="item$.selected" />{{'Select All'}}
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
                          {{item.productType}}
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item.productType}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item['text']}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-3 padding-r30">
                  <div class="category-dropdown material-select">
                    <ng-select [items]="truckLoadsizeData" [clearSearchOnAdd]="true"
                               [closeOnSelect]="false" labelForId="truckLoadsize" [multiple]="true" placeholder="Select Truck Load Size"
                               [(ngModel)]="searchTruckLoadSize" (change)="filterRecords()" [searchFn]="ddlOptionsSearchTruckLoadSize"
                               [selectableGroupAsModel]="false" groupBy="selectedAllGroupTruckLoadSize" [selectableGroup]="true" bindValue="truckLoadSize"
                               [keyDownFn]="handleKeyevent" clearAllText="Clear" [bindLabel]="'text'">
                      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index}}" type="checkbox"
                                 [ngModel]="item$.selected" />{{'Select All'}}
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
                          {{item.truckLoadSize}}
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item.truckLoadSize}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item['text']}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-3 padding-r30">
                  <div class="category-dropdown material-select">
                    <ng-select [items]="stateData" [clearSearchOnAdd]="true"
                               [closeOnSelect]="false" labelForId="state" [multiple]="true" placeholder="Select State"
                               [(ngModel)]="searchstate" (change)="filterRecords()" [searchFn]="ddlOptionsSearchState"
                               [selectableGroupAsModel]="false" groupBy="selectedAllGroupbranchState" [selectableGroup]="true" bindValue="stateDescription"
                               [keyDownFn]="handleKeyevent" clearAllText="Clear" [bindLabel]="'text'">
                      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index}}" type="checkbox"
                                 [ngModel]="item$.selected" />{{'Select All'}}
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
                          {{item.stateDescription}}
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item.stateDescription}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item['text']}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-3 padding-r30 search-btn text-right m-auto">
                  <button mat-raised-button class="btns" color="primary" (click)="onExportBtnClick()" [disabled]="SulfurZincPricingdListDataSource?.data.length <= 0">Export Data in Excel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="middleSection">
        <div class="row">
          <div class="col-6">
          </div>
          <div class="col-6 text-right padding-t15">
            <p class="display-ib">Last Refresh Date: <span>{{UpdateTimestamp | date:'MM/dd/yyyy' }}</span></p>
          </div>
        </div>
        <div class="col-md-12 padding-l30 padding-r0 padding-b10 padding-t10">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="row">
                <div class="col-md-9 padding-r30 padding-l0 text-left">
                  <div class="row">
                    <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                      <p *ngIf="currentFilter.filterDescription">REPORT NAME: {{currentFilter.filterDescription}}</p>
                    </div>
                    <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                      <p *ngIf="currentFilter.filterDescription">
                        LAST RUN DATE: {{(currentFilter.lastRunByTimeStamp || currentFilter.createTimeStamp) | date: 'MM/dd/yyyy'}}
                      </p>
                    </div>
                    <div class="col-sm-3 col-md-3">
                      <button mat-raised-button class="btns margin-r10" color="primary" (click)="editFilter()" *ngIf="(currentFilter.userReportFilterId || !(currentFilter.userReportFilterId)) && currentFilter.filterDescription">Edit Report</button>
                      <button mat-raised-button class="btns margin-r10" color="primary" (click)="save()" *ngIf="currentFilter.filterDescription">Save</button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 text-right">
                  <div class="padding-r0 ">
                    <button mat-raised-button class="btns" color="primary" (click)="addFilter()">Create Report</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomSection">
        <div class="row">
          <div class="col-md-12 productTableOuter">

            <div class="tableContainer cppSulfurZincPrincingTable priceListTable" id="cppSulfurZincPrincing">
              <table mat-table #placedCPPOrdersTable [dataSource]="SulfurZincPricingdListDataSource" multiTemplateDataRows class="matTables">
                <ng-container matColumnDef="stateDescription">
                  <th mat-header-cell *matHeaderCellDef> State </th>
                  <td mat-cell *matCellDef="let element"> {{element.stateDescription}} </td>
                </ng-container>
                <ng-container matColumnDef="truckLoadSize">
                  <th mat-header-cell *matHeaderCellDef> Truck Load Size </th>
                  <td mat-cell *matCellDef="let element"> {{element.truckLoadSize}} </td>
                </ng-container>
                <ng-container matColumnDef="productType">
                  <th mat-header-cell *matHeaderCellDef> Product Type </th>
                  <td mat-cell *matCellDef="let element"> {{element.productType}} </td>
                </ng-container>
                <ng-container matColumnDef="itemNumber">
                  <th mat-header-cell *matHeaderCellDef class="pb-2">
                    Item Number
                    <div>
                      <mat-form-field>
                        <mat-label>Item Number Filter</mat-label>
                        <input [(ngModel)]="filteredValues.itemNumber" matInput (ngModelChange)="filterByItemNumber($event)" />
                      </mat-form-field>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.itemNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="itemDesc">
                  <th mat-header-cell *matHeaderCellDef class="pb-2">
                    Item Description
                    <div>
                      <mat-form-field>
                        <mat-label>Item Description Filter</mat-label>
                        <input matInput [(ngModel)]="filteredValues.itemDesc" (ngModelChange)="filterByItemDesc($event)" />
                      </mat-form-field>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.itemDesc}} </td>
                </ng-container>
                <ng-container matColumnDef="itemDesc2">
                  <th mat-header-cell *matHeaderCellDef>
                    Package Size
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.itemDesc2}} </td>
                </ng-container>
                <ng-container matColumnDef="price">
                  <th mat-header-cell *matHeaderCellDef> Price </th>
                  <td mat-cell *matCellDef="let element"> {{element.price}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
              <div *ngIf="SulfurZincPricingdListDataSource == undefined || SulfurZincPricingdListDataSource?.data.length == 0" class="noDataMsg">
                <p>No PriceList found.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
